// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMemberAreaResponse

import { WidgetAuthMode } from './enums.gen';

export type WidgetMemberAreaApiResponse = {
	authMode: WidgetAuthMode;
	authMandatory: boolean;
	oktaIssuer: string | null;
	oktaClientId: string | null;
	jwksUrl: string | null;
	jwksIssuer: string | null;
};

export type WidgetMemberArea = {
	authMode: WidgetAuthMode;
	authMandatory: boolean;
	oktaIssuer: string | null;
	oktaClientId: string | null;
	jwksUrl: string | null;
	jwksIssuer: string | null;
};

export function hydrateWidgetMemberArea(data: WidgetMemberAreaApiResponse): WidgetMemberArea {
	return { ...data };
}